import React from 'react';
import { Box } from '@mui/material';
import { useSortable } from '@dnd-kit/sortable';
import { SortableTreeItemProps } from './types';
import { getSortableTreeItemSx } from './styles';

export function SortableTreeItem({
  node,
  children,
}: SortableTreeItemProps): React.ReactElement {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({
    id: node.id,
    data: {
      type: node.type,
      node,
    },
  });

  const dragHandleProps: React.HTMLAttributes<HTMLElement> = {
    ...attributes,
    ...listeners,
  };

  const shouldUseHandle = typeof children === 'function';

  return (
    <Box
      ref={setNodeRef}
      sx={getSortableTreeItemSx({ transform, transition, isDragging })}
      {...(!shouldUseHandle ? attributes : {})}
      {...(!shouldUseHandle ? listeners : {})}
    >
      <Box sx={{ flex: 1, width: '100%', maxWidth: '100%', minWidth: 0 }}>
        {typeof children === 'function' ? children(dragHandleProps) : children}
      </Box>
    </Box>
  );
}
